export default __webpack_public_path__ + "static/media/arrow-up.02c44f55.svg";